<p-toast key="globalToast">
<ng-template let-message pTemplate="message">
    <div [attr.role]="message.severity" aria-live="assertive" aria-atomic="true" class="p-toast-message-content">
        <span class="p-toast-message-icon pi pi-info-circle"></span>
        <div class="p-toast-message-text">
            <div class="p-toast-summary" [innerHTML]="message.summary | dompurify"></div>
            <div class="p-toast-detail" [innerHTML]="message.detail | dompurify"></div>
        </div>
    </div>
</ng-template>
</p-toast>



